<template>
    <LandingPageLayout
        v-bind="landingPageSharedData.getLandingPageLayoutProps()"
    >
        <article class="max-w-4xl mx-auto py-4 px-6 lg:px-0 flex-1">
            <div class="space-y-8 mb-20">
                <header>
                    <h1 class="text-3xl font-semibold">Refund Policy</h1>
                    <p>Last updated: December 30th, 2024</p>
                </header>

                <section class="space-y-2">
                    <div class="space-y-4">
                        <p>
                            At TinyCal, we strive to provide exceptional
                            software and services that meet your needs. This
                            Refund Policy outlines the terms and conditions
                            under which you may request and receive a refund for
                            our SaaS product. We believe in transparency and
                            want to ensure you understand our commitment to
                            customer satisfaction.
                        </p>
                    </div>
                </section>

                <section class="space-y-2">
                    <h2 class="text-xl font-semibold">
                        1. Monthly Subscriptions
                    </h2>
                    <div class="space-y-4">
                        <p>
                            Our Services are billed on a month-to-month basis.
                            You will be billed in advance on a recurring,
                            periodic basis (each period is called a “billing
                            cycle”), and each billing cycle is one month in
                            length.
                        </p>
                    </div>
                </section>

                <section class="space-y-2">
                    <h2 class="text-xl font-semibold">2. Refund Eligibility</h2>
                    <div class="space-y-4">
                        <p>
                            To be eligible to receive a refund from a paid
                            subscription you must request the refund within 30
                            days of subscribing to one of our paid plans.
                        </p>
                    </div>
                </section>

                <section class="space-y-2">
                    <h2 class="text-xl font-semibold">3. Refund Request</h2>
                    <div class="space-y-4">
                        <p>
                            To request a refund, please contact us at
                            "contact@tinycal.net". We will review your request
                            and respond as soon as possible.
                        </p>
                    </div>
                </section>

                <section class="space-y-2">
                    <h2 class="text-xl font-semibold">4. Cancellation</h2>
                    <div class="space-y-4">
                        <p>
                            You can cancel your subscription at any moment from
                            our dashboard, if you cancel your subscription
                            before the end of the current billing period, you
                            will retain access to the app ("grace period") until
                            the end of your billing cycle, and you will not be
                            charged again after it ends.
                        </p>
                    </div>
                </section>

                <section class="space-y-2">
                    <h2 class="text-xl font-semibold">5. Legal Compliance</h2>
                    <div class="space-y-4">
                        <p>
                            Where a refund is required by law, for example, in
                            case of a failure on our part to deliver the
                            Services as promised, we will make such refunds in
                            accordance with the relevant law.
                        </p>
                    </div>
                </section>

                <section class="space-y-2">
                    <h2 class="text-xl font-semibold">6. Updates</h2>
                    <div class="space-y-4">
                        <p>
                            We reserve the right to modify this Refund Policy at
                            any time, so please review it frequently. If we make
                            significant changes to this policy, we will notify
                            you here, by email, or by means of a notice on our
                            home page.
                        </p>
                    </div>
                </section>

                <section class="space-y-2">
                    <h2 class="text-xl font-semibold">
                        7. Contact Information
                    </h2>
                    <div class="space-y-4">
                        <p>If you have any questions please contact us at:</p>
                        <p>
                            Name: Isaac Souza Silva
                            <br />
                            CPF: 052.379.873-38
                            <br />
                            Email: contact@tinycal.net
                            <br />
                            Address: Av. 07, Qd. 19, N. 17, Caxias, MA,
                            65604660, Brazil
                        </p>
                    </div>
                </section>
            </div>
        </article>
    </LandingPageLayout>
</template>

<script setup lang="ts">
    import LandingPageLayout from '@/Marketing/LandingPage/Shared/LandingPageLayout.vue'
    import LandingPageSharedData from '@/Marketing/LandingPage/Entity/LandingPageSharedData'

    interface LandingPageProps {
        landingPageSharedDataRawData: any
    }

    const props = defineProps<LandingPageProps>()
    const landingPageSharedData = LandingPageSharedData.hydrate(
        props.landingPageSharedDataRawData,
    )
</script>
